/**
 * Central internal linking map for SEO content clusters.
 */

import { BLOG_STUB_SLUGS } from '../Pages/Blog/blogStubSlugs';

export const VERTICAL_PATHS = {
  aerial: '/aerial',
  location: '/location-visualisation',
  ecommerce: '/e-commerce',
};

/** @type {Record<string, { vertical?: string, blogSlugs: string[] }>} */
export const BLOG_CLUSTER_LINKS = {
  'general-capture-guide': {
    blogSlugs: [],
  },
  'aerial-location-capture-sops': {
    vertical: VERTICAL_PATHS.aerial,
    blogSlugs: [
      'real-estate-aerial-3d-capture',
      'drone-to-3d-model-without-photogrammetry',
      'gaussian-splatting-vs-matterport',
      'site-documentation-for-investigations',
      '360-video-capture-sops',
    ],
  },
  '360-video-capture-sops': {
    blogSlugs: [
      'aerial-location-capture-sops',
      'general-capture-guide',
    ],
  },
  'e-commerce-capture-guide': {
    blogSlugs: [
      'gaussian-splatting-vs-matterport',
    ],
  },
  'drone-to-3d-model-without-photogrammetry': {
    vertical: VERTICAL_PATHS.aerial,
    blogSlugs: ['aerial-location-capture-sops', 'gaussian-splatting-vs-matterport'],
  },
  'gaussian-splatting-vs-matterport': {
    vertical: VERTICAL_PATHS.location,
    blogSlugs: [
      'real-estate-aerial-3d-capture',
      'drone-to-3d-model-without-photogrammetry',
      'aerial-location-capture-sops',
    ],
  },
  'real-estate-aerial-3d-capture': {
    vertical: VERTICAL_PATHS.aerial,
    blogSlugs: [
      'aerial-location-capture-sops',
      'gaussian-splatting-vs-matterport',
    ],
  },
  'site-documentation-for-investigations': {
    vertical: VERTICAL_PATHS.aerial,
    blogSlugs: [
      'aerial-location-capture-sops',
      'gaussian-splatting-vs-matterport',
      'drone-to-3d-model-without-photogrammetry',
    ],
  },
  '360-video-to-3d-scene': {
    vertical: VERTICAL_PATHS.location,
    blogSlugs: ['360-video-capture-sops', 'aerial-location-capture-sops', 'general-capture-guide'],
  },
};

function publishedBlogSlugs(slugs) {
  return slugs.filter((s) => !BLOG_STUB_SLUGS.has(s));
}

export const VERTICAL_RELATED_BLOGS = {
  [VERTICAL_PATHS.aerial]: publishedBlogSlugs([
    'aerial-location-capture-sops',
    'real-estate-aerial-3d-capture',
    'site-documentation-for-investigations',
    'drone-to-3d-model-without-photogrammetry',
    'gaussian-splatting-vs-matterport',
    'general-capture-guide',
  ]),
  [VERTICAL_PATHS.location]: publishedBlogSlugs([
    'real-estate-aerial-3d-capture',
    'gaussian-splatting-vs-matterport',
    '360-video-to-3d-scene',
    'general-capture-guide',
    'aerial-location-capture-sops',
  ]),
  [VERTICAL_PATHS.ecommerce]: publishedBlogSlugs([
    'e-commerce-capture-guide',
  ]),
};
